var map = {
	"./female/head/0.png": 130,
	"./male/head/0.png": 131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;


//////////////////
// WEBPACK FOOTER
// ./src/layers ^\.\/.*\/head\/0\.png$
// module id = 370
// module chunks = 0